import { SuggestionModel } from './suggestionModel';

export const models = {
    SuggestionModel
};
